/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ClearingHouseViewer } from "./ClearingHouseViewer";

export class ClearingHouseViewerFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _clearingHouse: string,
    overrides?: Overrides
  ): Promise<ClearingHouseViewer> {
    return super.deploy(
      _clearingHouse,
      overrides || {}
    ) as Promise<ClearingHouseViewer>;
  }
  getDeployTransaction(
    _clearingHouse: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_clearingHouse, overrides || {});
  }
  attach(address: string): ClearingHouseViewer {
    return super.attach(address) as ClearingHouseViewer;
  }
  connect(signer: Signer): ClearingHouseViewerFactory {
    return super.connect(signer) as ClearingHouseViewerFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ClearingHouseViewer {
    return new Contract(address, _abi, signerOrProvider) as ClearingHouseViewer;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ClearingHouse",
        name: "_clearingHouse",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "clearingHouse",
    outputs: [
      {
        internalType: "contract ClearingHouse",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "getMarginRatio",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_quoteToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "getPersonalBalanceWithFundingPayment",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "margin",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "getPersonalPositionWithFundingPayment",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int256",
                name: "d",
                type: "int256",
              },
            ],
            internalType: "struct SignedDecimal.signedDecimal",
            name: "size",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "margin",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "d",
                type: "uint256",
              },
            ],
            internalType: "struct Decimal.decimal",
            name: "openNotional",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "int256",
                name: "d",
                type: "int256",
              },
            ],
            internalType: "struct SignedDecimal.signedDecimal",
            name: "lastUpdatedCumulativePremiumFraction",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "liquidityHistoryIndex",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "blockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct ClearingHouse.Position",
        name: "position",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
      {
        internalType: "enum ClearingHouse.PnlCalcOption",
        name: "_pnlCalcOption",
        type: "uint8",
      },
    ],
    name: "getUnrealizedPnl",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "d",
            type: "int256",
          },
        ],
        internalType: "struct SignedDecimal.signedDecimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "isPositionNeedToBeMigrated",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
